import { render, staticRenderFns } from "./Game_YT_EventManage.vue?vue&type=template&id=87f671ce&scoped=true&"
import script from "./Game_YT_EventManage.vue?vue&type=script&lang=js&"
export * from "./Game_YT_EventManage.vue?vue&type=script&lang=js&"
import style0 from "./Game_YT_EventManage.vue?vue&type=style&index=0&id=87f671ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f671ce",
  null
  
)

export default component.exports